import axios from 'axios'

export default class BankID {
  constructor() {
    const client = axios.create({
      baseURL: process.env.VUE_APP_PROFILE_API + '/auth/bankid/profile/',
      timeout: 3000,
      responseType: 'json',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    this.client = client
  }

  /**
   * Initiate an auth request.
   *
   * Params:
   *   request = {
   *     personalNumber string // Optional
   *     autoStart      bool   // Required (Is the intention to autostart?)
   *     isMobile       bool   // Required (Is the requestor using a mobile device?)
   *     sameDevice     bool   // Required (Is the intention to auth on the same device?)
   *   }
   */
  auth(request) {
    return this.client.post('/auth', request)
  }

  /**
   * Collect current state of auth/sign request.
   * Requirement: Must not be called more than once every two seconds.
   *
   * Params:
   *   request = {
   *     orderRef               string // Required
   *     autoStart              bool   // Required (Is the intention to autostart?)
   *     isMobile               bool   // Required (Is the requestor using a mobile device?)
   *     sameDevice             bool   // Required (Is the intention to auth on the same device?)
   *     providedPersonalNumber bool   // Required (Was personalNumber provided to the auth?)
   *   }
   */
  collect(request) {
    return this.client.post('/collect', request)
  }

  /**
   * Generate a new QR code from the orderRef.
   * Requirement: Must be called every second when the status is pending.
   */
  qrcode(orderRef) {
    return this.client.get(`/qrcode/${orderRef}`)
  }
}
